module.exports = __webpack_public_path__ + "static/media/ShortArrowDownWhite.917f2f41.svg";